<template>
  <ul class="flex items-center gap-4">
    <li>
      <a
        href="https://www.linkedin.com/company/landelijke-inspectiedienst-dierenbescherming"
        :title="t_('lid-on-social-media-linkedin')"
        target="_blank"
        class="hover:text-app-lid--yellow-casablanca transform transition duration-200 ease-in-out"
      >
        <AtomIconAppLinkedIn class="w-6" />
      </a>
    </li>
    <li>
      <a
        href="https://twitter.com/Inspectie_LID"
        :title="t_('lid-on-social-media-twitter')"
        target="_blank"
        class="hover:text-app-lid--yellow-casablanca transform transition duration-200 ease-in-out"
      >
        <AtomIconAppXFormerlyKnownAsTwitter class="w-6" />
      </a>
    </li>
    <li>
      <a
        href="https://www.facebook.com/Inspectiedienst/"
        :title="t_('lid-on-social-media-facebook')"
        target="_blank"
        class="hover:text-app-lid--yellow-casablanca transform transition duration-200 ease-in-out"
      >
        <AtomIconAppFacebook class="w-6" />
      </a>
    </li>
    <li>
      <a
        href="https://www.instagram.com/inspectiedienst/"
        :title="t_('lid-on-social-media-instagram')"
        target="_blank"
        class="hover:text-app-lid--yellow-casablanca transform transition duration-200 ease-in-out"
      >
        <AtomIconInstagram class="w-6" />
      </a>
    </li>
    <li>
      <a
        href="https://www.youtube.com/channel/UCmxz4V8rCv7Qwt1lKl_HuUw"
        :title="t_('lid-on-social-media-youtube')"
        target="_blank"
        class="hover:text-app-lid--yellow-casablanca transform transition duration-200 ease-in-out"
      >
        <AtomIconAppYoutube class="w-6" />
      </a>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { setupTranslationPrefixer } from '~/composables/util'

const { t_ } = setupTranslationPrefixer('lid-footer-social-media')
</script>
